// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" ng-bind=\"row.entity.externalReference | invEmpty\"></div>\n</div>\n";
// Exports
module.exports = code;